$(document).ready(function () {
  const swiper = new Swiper(".addon_carousel_holder", {
    slidesPerView: 3,
    slidesPerGroup: 2,
    spaceBetween: 30,
    mousewheel: {
      enabled: true,
      forceToAxis: true
    },
    pagination: {
      el: ".swiper_addon_pagination",
      clickable: true
    },
    breakpoints: {
      0: {
        slidesPerView: 2
      },
      768: {
        slidesPerView: 3
      },
      1024: {
        slidesPerView: 3
      }
    },
    autoplay: {
      delay: 5000
    }
  });
});
